import { LinkButton } from "~/common/components/Link";
import { useTranslation } from "react-i18next";
import { type MouseEventHandler } from "react";
import { Button } from "~/common/mui";
import RestartAltIcon from "@mui/icons-material/RestartAlt";

interface Props {
  className?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const ResetAllBtn = (props: Props) => {
  const { t } = useTranslation();
  return (
    <Button variant={"text"} startIcon={<RestartAltIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />} {...props}>
      {t("page.selectionAssistant.resetAllFilters")}
    </Button>
  );
};

export const ResetAllLinkBtn = (props: Props) => {
  const { t } = useTranslation();
  return (
    <LinkButton iconBefore={<RestartAltIcon sx={{ fontSize: { phone: 16, tablet: 20 } }} />} {...props}>
      {t("page.selectionAssistant.resetAllFilters")}
    </LinkButton>
  );
};
